export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=2ace311c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/kra/index.vue?vue&type=template&id=2ace311c&scoped=true
// module id = 2ZK/
// module chunks = 0